import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import {
    CREATE_COMPACTING_DC_DETAILS_FAILURE,
    CREATE_COMPACTING_DC_DETAILS_REQUEST,
    CREATE_COMPACTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_COMPACTING_DC_DETAILS,
    DELETE_COMPACTING_DC_DETAILS_FAILURE,
    DELETE_COMPACTING_DC_DETAILS_REQUEST,
    DELETE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_SUCCESS,
    COMPACTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_COMPACTING_DC_DETAILS_FAILURE,
    UPDATE_COMPACTING_DC_DETAILS_REQUEST,
    UPDATE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST,
    FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS,
    FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE,
    COMPACTING_DC_PROGRAM_ID_REQUEST,
    COMPACTING_DC_PROGRAM_ID_FAILURE,
    COMPACTING_DC_PROGRAM_ID_SUCCESS,
    FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_REQUEST,
    FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_SUCCESS,
    FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_FAILURE,
    FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_FAILURE,
    FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_REQUEST,
    FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_SUCCESS,
    DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_REQUEST,
    DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_SUCCESS,
    DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_FAILURE
} from './compactingDivisionDetails.actionsType';

// FETCH PROPERTY MASTER
export let fetchCompactingDCDetailsById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDivisionDetailsGET_BY_ID}?FldFKRNNo=${id}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE
    };
    return axiosCall(config);
};
export let getCompactingDivisionDetailsById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDivisionDetailsEditGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_FAILURE
    };
    return axiosCall(config);
};


export let deleteCompactingDivDetails = (id, reason, gridId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.compactingDivisionDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_REQUEST,
        responseTypeSuccess: DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_SUCCESS,
        responseTypeFailure: DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_FAILURE,
        getAllData: fetchCompactingDCDetailsById(parseInt(gridId)),
    };

    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchCompactingDCDetails = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCDetailsGET}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_FAILURE
    };
    return axiosCall(config);
};

export let fetchCompactingDCDetailsPreviousProgram = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCDetailsProgramGET}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createCompactingDCDetailsUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COMPACTING_DC_DETAILS, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createCompactingDCDetails = (formData, modalClose, fldFKStyle, fldFkProgramId, previousId) => {

    let today = new Date();

    let data = JSON.stringify({
        fldId: 0,
        fldFKRNNo: parseInt(formData.fldFKRNNo),
        //fldReceivingRolls: 0,
        //FldFKPreviousDCPO: parseInt(formData.FldFKPreviousDCPO),
        fldInwardDia: formData.fldInwardDia,
        fldFKInwardDia: parseInt(formData.fldFKInwardDia),
        fldFKRequiredDia: parseInt(formData.fldFKRequiredDia),

        //FldPreviousDCPO: formData.FldPreviousDCPO,
        // FldFKProgram: parseInt(formData.FldFKProgram),
        // FldProgram: formData.FldProgram,
        // fldFKFabricOrDyeingDc: parseInt(formData.fldFKFabricOrDyeingDc),
        // fldFKColour: parseInt(formData.fldFKColour),
        // fldDCNo: formData?.fldDCNo,
        //fldFKStyle: parseInt(formData.fldFKStyle),
        //fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldSalesOrderNo: formData.fldSalesOrderNo,
        fldFKYarnCount: parseInt(formData.fldFKYarnCount) || 0,
        fldYarnCount: formData?.fldYarnCount,
        fldStyleNumber: formData?.fldStyleNumber,
        fldStyleDescription: '',
        fldGSM: parseInt(formData.fldGSM),
        fldFKColour: parseInt(formData.fldFKColour),
        //fldFKColourShade: parseInt(formData.fldFKColourShade),
        fldColourShade: formData?.fldColourShade,
        // fldFabricOrDyeingDC: formData?.fldFabricOrDyeingDC,
        fldColour: formData?.fldColour,
        fldFabricGroup: formData?.fldFabricGroup,
        fldFabric: formData?.fldFabric,
        fldFabricname: formData?.fldFabricname,
        fldYarnCounts: formData?.fldYarnCounts,
        //fldDia: formData?.fldDia,
        //fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldRate: Number(formData.fldRate),
        fldQuantity: parseFloat(formData.fldFKWeightinKG) || 0,
        //fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        //fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        //fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        //fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        //fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        //fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        // fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        // fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        // fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        // fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        // fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        //fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        //fldFKProgram: Number(formData.fldFKProgram),
        //fldProgram: formData.fldProgram,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.fldEnteredSysId,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldUOM: formData.fldUOM,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFKFabricType: parseInt(formData.fldFKFabricType) || parseInt(formData.fldFKFabric),
        //fldFKFabric: parseInt(formData.fldFKFabric),
        // fldFKDia: parseInt(formData.fldFKDia),
        fldFKGSM: parseInt(formData.fldFKGSM),
        fldFKNoofRolls: parseInt(formData.fldFKNoofRolls),
        fldRequiredDia: formData?.fldRequiredDia.toString(),
        fldDespatchQuantity: Number(formData?.fldDespatchQuantity) || 0,
        despatchDate: today.toISOString(),
        fldFKWeightinKG: 0,
        //fldFKRatePerKG: 0,
        //fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: Number(formData?.fldBalanceQuantity) || 0,
        fldProcessLoss: parseFloat(formData?.fldProcessLoss) || 0,
        fldFKDyeingDCDetailId: parseInt(formData?.fldFKDyeingDCDetailId),
        fldBCDia: formData?.fldBCDia,
        fldBCGSM: formData?.fldBCGSM,
        fldACDia: formData?.fldACDia,
        fldACGSM: formData?.fldACGSM,
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.compactingDivisionDetailsPOST}?FldFKDCDetailNo=${previousId}`,
        responseTypeRequest: CREATE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_COMPACTING_DC_DETAILS_FAILURE,
        resetFormData: COMPACTING_DC_DETAILS_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        // getAllData: fetchCompactingDCDetailsById(parseInt(formData.fldFKDCNo))


        getAllData: fetchCompactingDCDetailsById(parseInt(formData.fldFKRNNo)),
        //fetchCompactingDCPreviousGetList(fldFKStyle, 0, fldFkProgramId)

    };


    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleCompactingDCDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCDetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE,
        singlApiArray: [
            // fetchYarnPODetailsGroupListDropdown(),
            // fetchKnittingDCPreviousGetList(),
            // fetchCommonPropertyById(57), // agent name
            // fetchCommonPropertyById(58), // mill name
            // fetchCommonPropertyById(22), // UOM
            // fetchHSNMaster(),
            // fetchColorDetailsWithoutId(),
            // fetchYarnPOOfPoNo()
        ]
    };
    return axiosCall(config);
};

// export let fetchCompactingDCPreviousGetList = (style, value, fkDetailID) => {
//     let config = {
//         method: 'get',
//         url: `${ConstantApi.compactingDCPreviousGetList}?FldFKStyleId=${style}&FldFKStyleDetailId=${fkDetailID}&FldFkProgramCode=COD&IsUpdated=${value}`,
//         responseTypeRequest: FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST,
//         responseTypeSuccess: FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS,
//         responseTypeFailure: FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE
//     };
//     return axiosCall(config);
// };

//UPDATE PROPERTY MASTER
export let updateCompactingDCDetails = (id, formData, parentId) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldId: parseInt(id),
        fldFKRNNo: parseInt(formData.fldFKRNNo),
        //fldReceivingRolls: 0,
        //FldFKPreviousDCPO: parseInt(formData.FldFKPreviousDCPO),
        fldInwardDia: formData.fldInwardDia,
        fldFKInwardDia: parseInt(formData.fldFKInwardDia),
        fldFKRequiredDia: parseInt(formData.fldFKRequiredDia),

        //FldPreviousDCPO: formData.FldPreviousDCPO,
        // FldFKProgram: parseInt(formData.FldFKProgram),
        // FldProgram: formData.FldProgram,
        // fldFKFabricOrDyeingDc: parseInt(formData.fldFKFabricOrDyeingDc),
        // fldFKColour: parseInt(formData.fldFKColour),
        // fldDCNo: formData?.fldDCNo,
        //fldFKStyle: parseInt(formData.fldFKStyle),
        //fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldSalesOrderNo: formData.fldSalesOrderNo,
        fldFKYarnCount: parseInt(formData.fldFKYarnCount) || 0,
        fldYarnCount: formData?.fldYarnCount,
        fldStyleNumber: formData?.fldStyleNumber,
        fldStyleDescription: '',
        fldGSM: parseInt(formData.fldGSM),
        fldFKColour: parseInt(formData.fldFKColour),
        //fldFKColourShade: parseInt(formData.fldFKColourShade),
        fldColourShade: formData?.fldColourShade,
        // fldFabricOrDyeingDC: formData?.fldFabricOrDyeingDC,
        fldColour: formData?.fldColour,
        fldFabricGroup: formData?.fldFabricGroup,
        fldFabric: formData?.fldFabric,
        fldFabricname: formData?.fldFabricname,
        fldYarnCounts: formData?.fldYarnCounts,
        //fldDia: formData?.fldDia,
        //fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldRate: Number(formData.fldRate),
        fldQuantity: parseFloat(formData.fldFKWeightinKG) || 0,
        //fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        //fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        //fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        //fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        //fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        //fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        // fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        // fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        // fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        // fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        // fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        //fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        //fldFKProgram: Number(formData.fldFKProgram),
        //fldProgram: formData.fldProgram,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.fldEnteredSysId,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        //fldUOM: formData.fldUOM,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFKFabricType: parseInt(formData.fldFKFabricType) || parseInt(formData.fldFKFabric),
        //fldFKFabric: parseInt(formData.fldFKFabric),
        // fldFKDia: parseInt(formData.fldFKDia),
        fldFKGSM: parseInt(formData.fldFKGSM),
        fldFKNoofRolls: parseInt(formData.fldFKNoofRolls),
        fldRequiredDia: formData?.fldRequiredDia.toString(),
        fldDespatchQuantity: Number(formData?.fldDespatchQuantity) || 0,
        despatchDate: today.toISOString(),
        fldFKWeightinKG: 0,
        //fldFKRatePerKG: 0,
        //fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: Number(formData?.fldBalanceQuantity) || 0,
        fldProcessLoss: parseFloat(formData?.fldProcessLoss) || 0,
        fldFKDyeingDCDetailId: parseInt(formData?.fldFKDyeingDCDetailId),
        fldBCDia: formData?.fldBCDia,
        fldBCGSM: formData?.fldBCGSM,
        fldACDia: formData?.fldACDia,
        fldACGSM: formData?.fldACGSM,
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.compactingDivisionDetailsUPDATE}/${id}`,
        responseTypeRequest: UPDATE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_COMPACTING_DC_DETAILS_FAILURE,
        resetFormData: COMPACTING_DC_DETAILS_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCompactingDCDetailsById(parentId)
    };
    return axiosCall(config);
};


// DELETE PROPERTY MASTER
export let deleteCompactingDCDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.compactingDCDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_COMPACTING_DC_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchCompactingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

export let fetchCompactingDCNoInDyeing = (styleNo, ProgramId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDcDetailsDCNoGET}?ActionCode=COD&StyleNO=${styleNo}&FldFKProgram=${ProgramId}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE
    };
    return axiosCall(config);
};

export let fetchGRNNoByCompactingDC = (DcNo, styleNo, value, ProgramId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.GRNNoByCompactingGET}?FldPONO=${DcNo}&StyleNo=${styleNo}&IsUpdated=${value}&FldFKProgram=${ProgramId}`,
        responseTypeRequest: FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST,
        responseTypeSuccess: FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS,
        responseTypeFailure: FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE
    };
    return axiosCall(config);
};

export let getStyleProgramId = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDivisionMasterGETID}/${id}`,
        responseTypeRequest: COMPACTING_DC_PROGRAM_ID_REQUEST,
        responseTypeSuccess: COMPACTING_DC_PROGRAM_ID_SUCCESS,
        responseTypeFailure: COMPACTING_DC_PROGRAM_ID_FAILURE
    };
    return axiosCall(config);
};

export let fetchcompactingDivisionPreviousGetList = (id, code) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDivisionDetailsPreviousListNewGET}?FldFKDC=${id}&FldCompanyCode=${code}`,
        responseTypeRequest: FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_FAILURE
    };
    return axiosCall(config);
};
